<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <group-form />
      </div>
    </div>
  </section>
</template>

<script>
import groupForm from './Temp/GroupFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'group-form': groupForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrGroup.vue?7d04814c